import { BOOKING_APIS } from "@/api_framework/api_config";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "../../useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import { IAhsBookingLinkParams } from "./useAhsBookingLinkScriptAPI";

AxiosCurlirize(axios, () => {});

export interface ISendAhsBookingLinkWhatsappParams extends IAhsBookingLinkParams {
  mobile: string;
}

export interface ISendAhsBookingLinkWhatsappData {
  whatsapp_sent: boolean;
  sms_sent: boolean;
  link_url?: string;
}

export interface ISendAhsBookingLinkWhatsappResponse {
  status: boolean;
  message: string;
  data?: ISendAhsBookingLinkWhatsappData | null;
}

export interface ISendAhsBookingLinkWhatsappResult {
  status: boolean;
  message: string;
  data: ISendAhsBookingLinkWhatsappData | null;
}

export const useSendAhsBookingLinkWhatsappAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (params: ISendAhsBookingLinkWhatsappParams): Promise<ISendAhsBookingLinkWhatsappResult> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const endpoint = BOOKING_APIS?.AHS_BOOKING_LINK_SEND?.baseURL ?? "";
        const body = Object.fromEntries(
          Object.entries(params).filter(([, value]) => value !== null && value !== undefined && `${value}` !== ""),
        );

        return await axios
          .post(endpoint, body, {
            headers: { Authorization: `${accessToken}` },
          })
          .then((res: AxiosResponse<ISendAhsBookingLinkWhatsappResponse>) => {
            if (res.data?.status === true) {
              return { status: true, message: res.data?.message ?? "sent", data: res.data?.data ?? null };
            }
            toast.error(res.data?.message || "Failed to send booking link");
            return { status: false, message: res.data?.message ?? "failed", data: res.data?.data ?? null };
          })
          .catch((e: AxiosError) => {
            sendCurl(e?.config?.["curlCommand"]);
            captureError(e);
            toast.error("Failed to send booking link");
            const errorData = (e?.response?.data as ISendAhsBookingLinkWhatsappResponse | undefined) ?? null;
            return { status: false, message: errorData?.message ?? e?.message ?? "failed", data: errorData?.data ?? null };
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return { status: false, message: e?.message ?? "error", data: null };
      }
    },
    [configuration, sendCurl, captureError],
  );

  return { execute };
};
